import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { NIJBUserCodeDTO, UserCodeClient } from '../api/proxy';

const CACHE_SIZE = 1;
const PROJECT_TYPE = 'PROJECT_TYPE';
const PROJECT_FOCUS = 'PROJECT_FOCUS';
const ATDT = 'ATDT';

@Injectable({
  providedIn: 'root',
})
export class UserCodeCacheService {
  constructor(private readonly userCodeClient: UserCodeClient) {}

  get projectTypes$(): Observable<NIJBUserCodeDTO[]> {
    return this.userCodeClient.getAllByField(PROJECT_TYPE).pipe(shareReplay(CACHE_SIZE));
  }

  get projectFocuses$(): Observable<NIJBUserCodeDTO[]> {
    return this.userCodeClient.getAllByField(PROJECT_FOCUS).pipe(shareReplay(CACHE_SIZE));
  }

  get attachmentDocumentTypes$(): Observable<NIJBUserCodeDTO[]> {
    return this.userCodeClient.getAllByField(ATDT).pipe(shareReplay(CACHE_SIZE));
  }
}
